import { render } from "./HomeButton.vue?vue&type=template&id=97413824&scoped=true&ts=true"
import script from "./HomeButton.vue?vue&type=script&lang=ts"
export * from "./HomeButton.vue?vue&type=script&lang=ts"

import "./HomeButton.vue?vue&type=style&index=0&id=97413824&lang=scss&scoped=true"

import exportComponent from "/home/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97413824"]])

export default __exports__